import { getCampaigns } from "../../data/campaigns";

const reducerKey = "campaignSearch";

export const getIsLoading = (state) => {
  return state[reducerKey].get("isLoading");
};

export const getQuery = (state) => {
  return state[reducerKey].get("query");
};

export const getSelectedCategory = (state) => state[reducerKey].get("selectedCategory");

export const getFilteredCampaigns = (state) => {
  const query = getQuery(state);
  const category = getSelectedCategory(state);

  const nameMatch = (campaign) =>
    campaign.get("name").toLowerCase().includes(query.toLowerCase());

  const categoryMatch = (campaign) =>
    (campaign.get("category") || "").toLowerCase().includes(query.toLowerCase());

  return getCampaigns(state)
    .filter((campaign) => {
      if (category && campaign.get("category")) {
        return campaign.get("category").toLowerCase() === category.toLowerCase();
      }

      return true;
    })
    .filter((campaign) => nameMatch(campaign) || categoryMatch(campaign))
    .sort((campaignA, campaignB) => {
      if (nameMatch(campaignA) && !nameMatch(campaignB)) {
        return -1;
      } else if (!nameMatch(campaignA) && nameMatch(campaignB)) {
        return 1;
      }

      return 0;
    });
};
